export const citiesInfo = [
  { id: 440200, city: '韶关', top: 0.04, left: 2.43, scale: 0.8 },
  { id: 441400, city: '梅州', top: 0.3, left: 3.65, scale: 0.8 },
  { id: 441600, city: '河源', top: 0.4, left: 2.96, scale: 1 },
  { id: 441800, city: '清远', top: 0.2, left: 1.69, scale: 1 },
  { id: 445100, city: '潮州', top: 0.47, left: 4.12, scale: 0.8 },
  { id: 445200, city: '揭阳', top: 0.99, left: 3.79, scale: 0.8 },
  { id: 440500, city: '汕头', top: 0.83, left: 4.12, scale: 0.8 },
  { id: 441500, city: '汕尾', top: 1.14, left: 3.28, scale: 1 },
  { id: 441300, city: '惠州', top: 0.99, left: 2.86, scale: 1 },
  { id: 440100, city: '广州', top: 0.72, left: 2.27, scale: 1 },
  { id: 440600, city: '佛山', top: 1.14, left: 1.8, scale: 1 },
  { id: 441200, city: '肇庆', top: 0.72, left: 1.36, scale: 1 },
  { id: 440300, city: '深圳', top: 1.3, left: 2.62, scale: 0.8 },
  { id: 441900, city: '东莞', top: 1.14, left: 2.36, scale: 0.8 },
  { id: 442000, city: '中山', top: 1.36, left: 2.01, scale: 0.8 },
  { id: 440700, city: '江门', top: 1.77, left: 1.59, scale: 1 },
  { id: 445300, city: '云浮', top: 1.2, left: 1.09, scale: 0.8 },
  { id: 440400, city: '珠海', top: 1.67, left: 2.16, scale: 0.8 },
  { id: 441700, city: '阳江', top: 1.88, left: 1.09, scale: 0.8 },
  { id: 440900, city: '茂名', top: 1.77, left: 0.53, scale: 1 },
  { id: 440800, city: '湛江', top: 2.29, left: 0.1, scale: 1 }
]

export function getFlagsLocation (cityCodes) {
  let len = cityCodes.length
  const flagsInfo = []
  citiesInfo.every(cityInfo => {
    if (cityCodes.some(cityCode => +cityCode === +cityInfo.id)) {
      len--
      flagsInfo.push(cityInfo)
    }
    return len
  })
  return flagsInfo
}
